import { Injectable } from '@angular/core';
import { Subject } from 'rxjs'


import {GraphSearchItemServiceService} from '../services/graph-search-item-service.service'

@Injectable({
  providedIn: 'root'
})
export class GraphSearchServiceService {

  constructor(
    private graphSearchItemService:GraphSearchItemServiceService
  ) { }

  graphSearchValue;

  graphVisual_sub = new Subject<any>();

  getGraphVisualData(graph){
    this.graphSearchValue = this.graphSearchItemService.getGraphSearchValue();
    this.graphSearchValue.graph = graph;
    this.graphVisual_sub.next();
  }

  getGraphSearchValue(){
    return this.graphSearchValue;
  }

  

}
